module.exports = __webpack_public_path__ + "img/genericLoad--isntSpanBySpan.056b06a5.png";